module.exports = __webpack_public_path__ + "img/icon_search_black.b2d0fc43.svg";